import React, { useState } from 'react'

export const QueueList = () => {
    // const { trackList, currentTrackName, playTrack, isPlaying } = useMusicPlayer()
    const [checked, setChecked] = useState( false )
    return (
        <div className="queue__wrapper">
            <article className="screen">
                <input type="checkbox" value="None" id="magicButton" name="check" />
                <label className="main" htmlFor="magicButton"></label>
                <div className="coverImage"></div>
                <div className="bodyPlayer"></div>
                <table className="queue__list">
                    <tbody>
                        <tr className="queue__item">
                            <td className="queue__item nr">
                                <h5>1</h5>
                            </td>
                            <td className="queue__item title">
                                <h5 style={{ color: "#ec1b25" }}>
                                    Henry Lee Ft. PJ Harvey</h5>
                                <span>Nick Cave & the bad seeds</span>
                            </td>
                            <td className="queue__item length">
                                <span>03:54</span>
                            </td>
                            <td className="queue__item svg">
                                <input type="checkbox" checked id="heart" />
                                <label className="heartSVG" htmlFor="heart"></label>
                            </td>
                        </tr>

                        <tr className="queue__item">
                            <td className="queue__item nr">
                                <h5>2</h5>
                            </td>
                            <td className="queue__item title">
                                <h5>Rusty Nails</h5>
                                <span>Moderat</span>
                            </td>
                            <td className="queue__item length">
                                <span>03:54</span>
                            </td>
                            <td className="queue__item svg">
                                <input type="checkbox" id="heart1" />
                                <label className="heartSVG" htmlFor="heart1"></label>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="shadow"></div>
                <div className="bar"></div>
                <div className="info">
                    <h4>Henry Lee Ft. PJ Harvey</h4>
                    <h3>Nick Cave & the bad seeds- Murder Balads</h3>
                </div>
                <table className="player">
                    <td>
                        <input type="checkbox" id="backward" />
                        <label className="backward" htmlFor="backward"></label>
                    </td>
                    <td>
                        <input type="checkbox" id="play" title="Play" onClick="togglePlayPause()" />
                        <label className="play" htmlFor="play"></label>
                    </td>
                    <td>
                        <input type="checkbox" id="forward" />
                        <label className="forward" htmlFor="forward"></label>
                    </td>
                </table>
                <table className="footer">
                    <td>
                        <input type="checkbox" id="love" className={`${checked} ? "checked" : ""`}
                            // onChange={checked}
                            onClick={() => setChecked( !checked )} />
                        <label className="love" htmlFor="love"></label>
                    </td>
                    <td>
                        <input type="checkbox" id="shuffle" />
                        <label className="shuffle" htmlFor="shuffle"></label>
                    </td>
                    <td>
                        <input type="checkbox" id="repeat" />
                        <label className="repeat" htmlFor="repeat"></label>
                    </td>
                    <td>
                        <input type="checkbox" id="options" />
                        <label className="options" htmlFor="options"></label></td>
                </table>
                <div className="current">
                    <h3>Henry Lee Ft. PJ Harvey</h3>
                </div>
            </article>
        </div>
    )
}

